export const KITCHEN_PRICE_PDP_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/v1693231994/fudzi/elbrus/images/landings/kitchen-price-pdp';

export const KITCHEN_PRICE_PDP_ELEMENT_BLOCK = 'proektKuhniDetail';

export const KITCHEN_PRICE_PDP_CATEGORY_ID = '1832';

export const KITCHEN_PRICE_PDP_LANDING_NAME = 'kitchen-price-pdp';
